import { useState } from "react";

interface Community {
  name: string;
  route: string;
}

interface Subregion {
  name: string;
  description: string;
  communities: Community[];
  hub: { name: string; route: string };
}

interface Region {
  id: string;
  name: string;
  icon: string;
  subregions: Subregion[];
}

const regions: Region[] = [
  {
    id: "nyc-metro",
    name: "NYC Metro",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "Manhattan",
        description: "Midtown, Downtown, Upper East Side, Upper West Side, Harlem, and the Financial District. All subway lines connect to the major hubs. LaGuardia (LGA) is in Queens; JFK is in Jamaica. Both are accessible via the AirTrain.",
        hub: { name: "New York City", route: "#" },
        communities: [
          { name: "Upper East Side", route: "#" }, { name: "Upper West Side", route: "#" },
          { name: "Harlem", route: "#" }, { name: "Financial District", route: "#" },
          { name: "SoHo", route: "#" }, { name: "Tribeca", route: "#" },
          { name: "Chelsea", route: "#" }, { name: "Greenwich Village", route: "#" },
          { name: "East Village", route: "#" }, { name: "West Village", route: "#" },
          { name: "Murray Hill", route: "#" }, { name: "Gramercy", route: "#" },
          { name: "Flatiron", route: "#" }, { name: "NoMad", route: "#" },
          { name: "Lower East Side", route: "#" }, { name: "Chinatown", route: "#" },
        ],
      },
      {
        name: "Brooklyn & Staten Island",
        description: "Williamsburg, Park Slope, Bay Ridge, and Coney Island are the major Brooklyn neighborhoods. The Staten Island Ferry connects to Manhattan. The Verrazzano Bridge connects to Brooklyn. Newark Liberty (EWR) is across the Hudson.",
        hub: { name: "Brooklyn", route: "#" },
        communities: [
          { name: "Williamsburg", route: "#" }, { name: "Park Slope", route: "#" },
          { name: "Bay Ridge", route: "#" }, { name: "Coney Island", route: "#" },
          { name: "Prospect Heights", route: "#" }, { name: "Crown Heights", route: "#" },
          { name: "Bedford-Stuyvesant", route: "#" }, { name: "Bushwick", route: "#" },
          { name: "Greenpoint", route: "#" }, { name: "Red Hook", route: "#" },
          { name: "DUMBO", route: "#" }, { name: "Brooklyn Heights", route: "#" },
          { name: "Staten Island", route: "#" }, { name: "St. George", route: "#" },
          { name: "Tottenville", route: "#" }, { name: "New Dorp", route: "#" },
        ],
      },
      {
        name: "Queens & Bronx",
        description: "Astoria, Flushing, Forest Hills, and Long Island City are the major Queens neighborhoods. The Bronx is north of Manhattan. Yankee Stadium is the landmark. The Cross Bronx Expressway and the Major Deegan are the major roads.",
        hub: { name: "Queens", route: "#" },
        communities: [
          { name: "Astoria", route: "#" }, { name: "Flushing", route: "#" },
          { name: "Forest Hills", route: "#" }, { name: "Long Island City", route: "#" },
          { name: "Jackson Heights", route: "#" }, { name: "Sunnyside", route: "#" },
          { name: "Woodside", route: "#" }, { name: "Elmhurst", route: "#" },
          { name: "Rego Park", route: "#" }, { name: "Jamaica", route: "#" },
          { name: "The Bronx", route: "#" }, { name: "Riverdale", route: "#" },
          { name: "Fordham", route: "#" }, { name: "South Bronx", route: "#" },
          { name: "Westchester Square", route: "#" }, { name: "Throgs Neck", route: "#" },
        ],
      },
      {
        name: "Westchester County",
        description: "Yonkers, New Rochelle, White Plains, Mount Vernon, and Scarsdale. The Metro-North Harlem and New Haven lines connect to Grand Central. The Cross Westchester Expressway (I-287) connects the county. The Saw Mill River Parkway is the scenic route.",
        hub: { name: "White Plains", route: "#" },
        communities: [
          { name: "Yonkers", route: "#" }, { name: "New Rochelle", route: "#" },
          { name: "Mount Vernon", route: "#" }, { name: "Scarsdale", route: "#" },
          { name: "Harrison", route: "#" }, { name: "Rye", route: "#" },
          { name: "Mamaroneck", route: "#" }, { name: "Larchmont", route: "#" },
          { name: "Pelham", route: "#" }, { name: "Eastchester", route: "#" },
          { name: "Tuckahoe", route: "#" }, { name: "Bronxville", route: "#" },
          { name: "Hastings-on-Hudson", route: "#" }, { name: "Dobbs Ferry", route: "#" },
          { name: "Irvington", route: "#" }, { name: "Tarrytown", route: "#" },
        ],
      },
    ],
  },
  {
    id: "long-island",
    name: "Long Island",
    icon: "ri-ship-line",
    subregions: [
      {
        name: "Nassau County",
        description: "Hempstead, Hicksville, Levittown, Mineola, and Garden City. The Long Island Rail Road (LIRR) connects to Penn Station. The Northern State and Southern State parkways are the major east-west routes. JFK is the nearest airport.",
        hub: { name: "Hempstead", route: "#" },
        communities: [
          { name: "Hicksville", route: "#" }, { name: "Levittown", route: "#" },
          { name: "Mineola", route: "#" }, { name: "Garden City", route: "#" },
          { name: "Westbury", route: "#" }, { name: "East Meadow", route: "#" },
          { name: "Wantagh", route: "#" }, { name: "Bellmore", route: "#" },
          { name: "Merrick", route: "#" }, { name: "Freeport", route: "#" },
          { name: "Oceanside", route: "#" }, { name: "Rockville Centre", route: "#" },
          { name: "Lynbrook", route: "#" }, { name: "Valley Stream", route: "#" },
          { name: "Elmont", route: "#" }, { name: "Floral Park", route: "#" },
        ],
      },
      {
        name: "Suffolk County",
        description: "Commack, Smithtown, Huntington, Bay Shore, Islip, and West Babylon. The LIRR Ronkonkoma and Port Jefferson branches serve Suffolk. The Long Island Expressway (I-495) is the main artery. MacArthur Airport (ISP) is in Ronkonkoma.",
        hub: { name: "Commack", route: "#" },
        communities: [
          { name: "Smithtown", route: "#" }, { name: "Huntington", route: "#" },
          { name: "Bay Shore", route: "#" }, { name: "Islip", route: "#" },
          { name: "West Babylon", route: "#" }, { name: "Northport", route: "#" },
          { name: "Dix Hills", route: "#" }, { name: "Hauppauge", route: "#" },
          { name: "Kings Park", route: "#" }, { name: "Brentwood", route: "#" },
          { name: "Central Islip", route: "#" }, { name: "Lindenhurst", route: "#" },
          { name: "North Babylon", route: "#" }, { name: "Babylon", route: "#" },
          { name: "Deer Park", route: "#" }, { name: "Patchogue", route: "#" },
        ],
      },
      {
        name: "East End — Hamptons & North Fork",
        description: "Southampton, East Hampton, Montauk, and Sag Harbor are the Hamptons. The North Fork is the quieter, wine-country side. The Jitney and the LIRR are the main connections. The ferries to Connecticut are an alternative route.",
        hub: { name: "Southampton", route: "#" },
        communities: [
          { name: "East Hampton", route: "#" }, { name: "Montauk", route: "#" },
          { name: "Sag Harbor", route: "#" }, { name: "Bridgehampton", route: "#" },
          { name: "Water Mill", route: "#" }, { name: "Wainscott", route: "#" },
          { name: "Amagansett", route: "#" }, { name: "Springs", route: "#" },
          { name: "Napeague", route: "#" }, { name: "North Fork", route: "#" },
          { name: "Greenport", route: "#" }, { name: "Southold", route: "#" },
          { name: "Cutchogue", route: "#" }, { name: "Mattituck", route: "#" },
          { name: "Jamesport", route: "#" }, { name: "Aquebogue", route: "#" },
        ],
      },
    ],
  },
  {
    id: "upstate-west",
    name: "Upstate & Western NY",
    icon: "ri-landscape-line",
    subregions: [
      {
        name: "Capital Region",
        description: "Albany, Troy, Schenectady, and Saratoga Springs. The state capital is the hub. The I-87 and I-90 are the major corridors. The Albany International Airport (ALB) is the main airport. The Saratoga Race Course is the summer attraction.",
        hub: { name: "Albany", route: "#" },
        communities: [
          { name: "Troy", route: "#" }, { name: "Schenectady", route: "#" },
          { name: "Saratoga Springs", route: "#" }, { name: "Rotterdam", route: "#" },
          { name: "Niskayuna", route: "#" }, { name: "Scotia", route: "#" },
          { name: "Ballston Spa", route: "#" }, { name: "Malta", route: "#" },
          { name: "Glens Falls", route: "#" }, { name: "Queensbury", route: "#" },
          { name: "Hudson Falls", route: "#" }, { name: "South Glens Falls", route: "#" },
          { name: "Rensselaer", route: "#" }, { name: "East Greenbush", route: "#" },
          { name: "Watervliet", route: "#" }, { name: "Cohoes", route: "#" },
        ],
      },
      {
        name: "Western New York",
        description: "Buffalo, Niagara Falls, Rochester, and Jamestown. The Buffalo Niagara International Airport (BUF) is the main airport. The I-90 and I-290 are the major corridors. The Niagara Falls are the major attraction.",
        hub: { name: "Buffalo", route: "#" },
        communities: [
          { name: "Niagara Falls", route: "#" }, { name: "Rochester", route: "#" },
          { name: "Jamestown", route: "#" }, { name: "North Tonawanda", route: "#" },
          { name: "Amherst", route: "#" }, { name: "Cheektowaga", route: "#" },
          { name: "West Seneca", route: "#" }, { name: "Lackawanna", route: "#" },
          { name: "Tonawanda", route: "#" }, { name: "Kenmore", route: "#" },
          { name: "Brighton", route: "#" }, { name: "Greece", route: "#" },
          { name: "Pittsford", route: "#" }, { name: "Henrietta", route: "#" },
          { name: "Irondequoit", route: "#" }, { name: "Webster", route: "#" },
        ],
      },
      {
        name: "Central New York",
        description: "Syracuse, Utica, Rome, and Binghamton. The I-90 and I-81 are the major corridors. The Syracuse Hancock International Airport (SYR) is the main airport. The Finger Lakes are the major attraction. Cornell University is in Ithaca.",
        hub: { name: "Syracuse", route: "#" },
        communities: [
          { name: "Utica", route: "#" }, { name: "Rome", route: "#" },
          { name: "Binghamton", route: "#" }, { name: "Liverpool", route: "#" },
          { name: "Dewitt", route: "#" }, { name: "Fayetteville", route: "#" },
          { name: "Manlius", route: "#" }, { name: "Camillus", route: "#" },
          { name: "New Hartford", route: "#" }, { name: "Whitesboro", route: "#" },
          { name: "Yorkville", route: "#" }, { name: "Johnson City", route: "#" },
          { name: "Vestal", route: "#" }, { name: "Endicott", route: "#" },
          { name: "Endwell", route: "#" }, { name: "Chenango Bridge", route: "#" },
        ],
      },
    ],
  },
  {
    id: "hudson-valley",
    name: "Hudson Valley",
    icon: "ri-map-2-line",
    subregions: [
      {
        name: "Mid-Hudson Valley",
        description: "Poughkeepsie, Newburgh, Kingston, and Middletown. The Metro-North Hudson Line connects to Grand Central. The I-84 and the Taconic State Parkway are the major roads. The Walkway Over the Hudson is the landmark.",
        hub: { name: "Poughkeepsie", route: "#" },
        communities: [
          { name: "Newburgh", route: "#" }, { name: "Kingston", route: "#" },
          { name: "Middletown", route: "#" }, { name: "Wappingers Falls", route: "#" },
          { name: "Hyde Park", route: "#" }, { name: "Rhinebeck", route: "#" },
          { name: "Red Hook", route: "#" }, { name: "Beacon", route: "#" },
          { name: "Cornwall", route: "#" }, { name: "Montgomery", route: "#" },
          { name: "Goshen", route: "#" }, { name: "Wallkill", route: "#" },
          { name: "New Paltz", route: "#" }, { name: "Woodstock", route: "#" },
          { name: "Saugerties", route: "#" }, { name: "Catskill", route: "#" },
        ],
      },
      {
        name: "Lower Hudson Valley",
        description: "The lower Hudson Valley is the suburban area north of NYC. Peekskill, Ossining, and Tarrytown are the river towns. The Metro-North Hudson Line connects to Grand Central. The Palisades Interstate Parkway is the scenic route.",
        hub: { name: "Peekskill", route: "#" },
        communities: [
          { name: "Ossining", route: "#" }, { name: "Tarrytown", route: "#" },
          { name: "Sleepy Hollow", route: "#" }, { name: "Irvington", route: "#" },
          { name: "Dobbs Ferry", route: "#" }, { name: "Hastings-on-Hudson", route: "#" },
          { name: "Yonkers", route: "#" }, { name: "New Rochelle", route: "#" },
          { name: "Mount Vernon", route: "#" }, { name: "Pelham", route: "#" },
          { name: "Eastchester", route: "#" }, { name: "Bronxville", route: "#" },
          { name: "Tuckahoe", route: "#" }, { name: "Scarsdale", route: "#" },
          { name: "Harrison", route: "#" }, { name: "Rye", route: "#" },
        ],
      },
    ],
  },
];

export default function NewYorkCommunitiesWeServe() {
  const [activeRegion, setActiveRegion] = useState(regions[0].id);

  const current = regions.find((r) => r.id === activeRegion) || regions[0];

  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Statewide Coverage
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Communities We Serve Across New York
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Don't see your city in the directory above? You're still covered. Every New York community below is served through our nearest hub — with the same fast, reliable expedited passport processing.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setActiveRegion(region.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeRegion === region.id
                  ? "bg-[#1A365D] text-white"
                  : "bg-[#EEF2F8] text-[#1A365D] hover:bg-[#dce5f3]"
              }`}
            >
              <i className={`${region.icon} text-base`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {current.subregions.map((sub, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start justify-between gap-4 mb-3">
                <h3 className="font-bold text-[#1A365D] text-base">{sub.name}</h3>
                <a
                  href={sub.hub.route}
                  className="flex-shrink-0 inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap"
                >
                  Hub: {sub.hub.name} <i className="ri-arrow-right-line"></i>
                </a>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{sub.description}</p>
              <div className="flex flex-wrap gap-2">
                {sub.communities.map((c, j) => (
                  <a
                    key={j}
                    href={c.route}
                    className="inline-flex items-center text-xs font-medium text-[#1A365D] bg-white border border-gray-200 rounded-full px-3 py-1 hover:border-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap cursor-pointer"
                  >
                    {c.name}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Not finding your exact community? <a href="tel:8772530084" className="text-[#1A365D] font-semibold hover:text-[#F6C344] transition-colors">Call us at 877-253-0084</a> — we serve all of New York.
        </p>
      </div>
    </section>
  );
}